module.exports = { "default": require("core-js/library/fn/object/create"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-link/~/babel-runtime/core-js/object/create.js
// module id = ./node_modules/gatsby-link/node_modules/babel-runtime/core-js/object/create.js
// module chunks = 168707334958949